<template lang="pug">
.wrapper
    .container.m-auto
        HeaderGlobal(HeaderGlobalHeading="Territory Virtual" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Detail Territory Virtual
                        .header-cta
                            router-link.btn-default.mr-5(to="/notification") Back
                            //- router-link.btn-primary(:to="'/territory-virtual/' + id + '/edit'") Edit
            .box__body.p-4
                .flex.-mx-4
                    .block.px-4(class="w-1/2")
                        span.text-light  Territory area
                        .draw-area.box-map

                            //- template(v-if="territory_virtual_detail_map_data.point || territory_virtual_detail_map_data.target")
                            template(v-if="territory_virtual_detail_map_data.point || territory_virtual_detail_map_data.target_history")
                                l-map#mapTeritory(v-if="vendorMap==='osm'"  ref="mapRefOSM" :zoom="10" :center="center" :options="options" style="height: 100%;width: 100%;")
                                    l-tile-layer(:url="url" :attribution="attribution")
                                    template(v-for="(location, index) in locations.territory")
                                        l-marker(:lat-lng="location.position" :icon="getMarkerOsmIcon(location)")
                                            l-popup(:content="location.name")
                                        l-circle(:lat-lng="location.position" :radius="circle_marker_radius" color="#000000" :weight="1.75" :fillColor="location.iconColor" :fillOpacity="0.25")
                                        //- l-circle(:lat-lng="location.position" :radius="circle_marker_radius" :color="location.iconColor" :weight="1.25" :fillColor="location.iconColor" :fillOpacity="0.25")

                                    l-rectangle(:bounds="rectangleOSM.bounds" :color="rectangleOSM.style.color" :weight="rectangleOSM.style.weight" :opacity="rectangleOSM.style.opacity" :fillColor="rectangleOSM.style.fillColor" :fillOpacity="rectangleOSM.style.fillOpacity")
                                
                                gmap-map(v-else ref="mapRefDetail" :center="center" :zoom="11" :options="options" style="width:100%; height: 100%;")
                            
                            NoDataAvailable(v-else)

                    .block.px-4(class="w-1/2")
                        .block.mb-4
                            span.text-light Territory Name
                            h3.font-normal.text-gray-500 {{ territory_virtual_detail_map_data.name ? territory_virtual_detail_map_data.name : '-' }}
                        
                        .block.mb-4.pt-4.border-t.border-dashed
                            span.text-light Description
                            h3.font-normal.text-gray-500 {{ territory_virtual_detail_map_data.description ? territory_virtual_detail_map_data.description : '-' }}
                        
                        //- template(v-if="territory_virtual_detail_map_data.target && territory_virtual_detail_map_data.target.length > 0")
                        template(v-if="territory_virtual_detail_map_data.target_history && territory_virtual_detail_map_data.target_history.length > 0")
                            .block.mb-4.pt-4.border-t.border-dashed
                                //- .choosen-target__list.rounded.mb-6(v-for="(target, index) in territory_virtual_detail_map_data.target" :key="index")
                                .choosen-target__list.rounded.mb-6(v-for="(target, index) in territory_virtual_detail_map_data.target_history" :key="index")
                                    .flex.items-center.justify-between.border-b.border-b.p-4
                                        .flex.items-center
                                            figure.w-6.h-6.mr-4
                                                img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="target.photo ? target.photo : getDefaultImage" @error="getDefaultImage")
                                            span.text-light.name-index {{ target.target_name ? target.target_name : '-' }}
                                            label(:class="[`inline-block w-4 h-4 rounded-full`]" :style="'background-color: '+ target.label +';'")

                                    .clues.flex.items-center.p-4
                                        .flex.items-center.mr-2(class="w-1/3" v-for="(msisdn, index) in target.coordinates" :key="index")
                                            strong {{ msisdn.msisdn }}

        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading History Territory Virtual List
                            //- label(v-if="territory_virtual_detail_map_data.target && territory_virtual_detail_map_data.target[0] && territory_virtual_detail_map_data.target[0].label" :class="[`inline-block bg-${territory_virtual_detail_map_data.target[0].label}-500 w-4 h-4 rounded-full`]")
                    .header-cta(style="min-width:240px")

                        .field.relative
                            .flex.flex-wrap.items-center.justify-between
                                .flex.flex-wrap.items-center
                                    span.mr-2 Show
                                        .field.mr-2.relative
                                            select.field-style#filter-record-size(@change="sizeChange($event)" v-model="items_per_page" style="min-width:80px")
                                                option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
                                            .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                    span entries

                    .field.relative.field-date-time-picker
                        date-range-picker(
                            v-if="dateRange.startDate && dateRange.endDate" 
                            ref="picker" 
                            v-model="dateRange" 
                            @update="pickerUpdate($event)" 
                            :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY' }" 
                            :date-format="dateFormat" 
                            opens="left" 
                            :ranges="default_ranges"
                            autoApply=true)
                            div(
                                slot="input" 
                                slot-scope="picker") 
                                | {{ picker.startDate | date}} - {{ picker.endDate  | date}}
                        .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>

            .box__body
                .history-area
                    .table-static.w-full.p-4
                        table
                            thead
                                tr
                                    th(v-for="(th,index) in tableThead" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')") {{ th.name }}
                            tbody
                                tr(v-if="load_data_status_territory_virtual_detail_history_list === 'loading'")
                                    td.text-center(:colspan="tableThead.length")
                                        .flex.flex-wrap.items-center.justify-center
                                            Spinner(show="true" size="48")
                                template(v-else-if="territory_virtual_detail_history_list.data && territory_virtual_detail_history_list.data.length > 0")
                                    tr(v-for="(territory,index) in territory_virtual_detail_history_list.data" :key="territory.id")
                                        //- td {{ territory.datetime_location ? datetimeFormat(territory.datetime_location) : '-' }}
                                        td {{ territory.datetime_location ? territory.datetime_location : '-' }}
                                        td {{ territory.msisdn ? territory.msisdn : '-' }}
                                        td {{ territory.location && territory.location[0] ? territory.location[0].lat + ', ' + territory.location[0].lng : '-' }}
                                        td.action 
                                            a.btn-icon.btn-default(v-if="territory.location && territory.location[0]" :href="'https://www.google.com/maps?q=' + territory.location[0].lat + ',' + territory.location[0].lng" target="_blank")
                                                .text-gray-600
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                                tr(v-else)
                                    td.text-center(:colspan="tableThead.length") No Data Available

                        .mt-5
                            vue-ads-pagination(
                                :total-items="total_data"
                                :items-per-page="items_per_page"
                                :page="page"
                                :max-visible-pages="5"
                            )
                                template(slot="buttons" slot-scope="props")
                                    vue-ads-page-button(
                                        v-for="(button, key) in props.buttons"
                                        :key="key"
                                        v-bind="button"
                                        :class="{'bg-yellow-dark': button.active}"
                                        @page-change="page = button.page"
                                        @range-change="start = button.start; end = button.end"
                                    )                                

</template>

<script>
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import { gmapApi } from 'vue2-google-maps';
import { mapState } from 'vuex';
import Spinner from '@/components/Spinner.vue';
import moment from 'moment';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import { decrypt } from '@/util/crypto';

// openstreetmap
import {LMap, LTileLayer, LMarker, LPopup, LPolyline, LRectangle, LCircle} from 'vue2-leaflet';
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.imagePath = ''
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
    name: 'PageTerritoryVirtualDetailNotification',
    components: {
        HeaderGlobal,
        Spinner,
        Loading,
        NoDataAvailable,
        DateRangePicker,
        VueAdsPagination,
        VueAdsPageButton,

        // opemapstreet
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LPolyline,
        LRectangle,
        LCircle,
    },
    data: function() {
        return {
            breadcrumb: [
                {
                    name: 'Territory Virtual',
                    url: '/territory-virtual',
                },
                {
                    name: "Notification Territory Virtual ",
                    url: '/territory-virtual/'+this.id+'/detail/notification/'+this.target_id+'/'+decrypt(this.msisdn),
                },
            ],

            // dummy
            dataHistoryTerritory: [
                {
                    id: 1,
                    target: 'agilbaka',
                    clue: `081234567890`,
                    time: '4 mei 2020 11:00 WIB',
                    location: 'Bandung',
                    view: true
                },
            ],

            // map
            options: {
                // zoomControl: true,
                // mapTypeControl: true,
                // scaleControl: true,
                // streetViewControl: true,
                // rotateControl: true,
                // fullscreenControl: false,
                // disableDefaultUi: false
                // scrollwheel: false,
                gestureHandling: 'cooperative',
                styles: [
                    {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                    {
                      featureType: 'administrative.locality',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'poi',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'geometry',
                      stylers: [{color: '#263c3f'}]
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#6b9a76'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry',
                      stylers: [{color: '#38414e'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#212a37'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#9ca5b3'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry',
                      stylers: [{color: '#746855'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#1f2835'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#f3d19c'}]
                    },
                    {
                      featureType: 'transit',
                      elementType: 'geometry',
                      stylers: [{color: '#2f3948'}]
                    },
                    {
                      featureType: 'transit.station',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'geometry',
                      stylers: [{color: '#17263c'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#515c6d'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.stroke',
                      stylers: [{color: '#17263c'}]
                    }
                ],
            },
            infoWindows: [],
            mapLoaded: false,
            center: {},
            markers: [],
            // places: [],
            // heatmap: null,
            mapsLatLng: [],
            polyline: null,

            rectangle_data: {},
            // rectangle_bounds: [],

            // default rectangle bounds -> monas, jakarta
            bounds: {
                north: -6.170255000000001,
                east: 106.83286432275388,
                south: -6.18188099999998,
                west: 106.8211273227539,
            },

            ImgAvatar: require('../../assets/no-image-profile.jpg'),

            target_selected: {},
            msisdn_selected: '',
            from_date: '',
            to_date: '',

            marker_color: {
                green: '#48bb78',
                red: '#f56565',
                purple: '#9f7aea',
                orange: '#ed8936',
                blue: '#4299e1',
            },

            // date picker
            dateRange: {
                // startDate: null,
                // endDate: null,
                // startDate: moment().toDate(),
                // endDate: moment().toDate(),
                startDate: '',
                endDate: '',
            },
            default_ranges: {
                'Today': [moment().toDate(), moment().toDate()],
                'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
                // 'This month': [moment().startOf('month'), moment().endOf('month')],
                // 'This year': [moment().startOf('year'), moment().endOf('year')],
                'Last 7 days': [moment().subtract(6, 'days').toDate(), moment().toDate()],
                'Last week': [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()],
                // 'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            },

            // pagination history
            tableThead: [
                {
                    name: 'Datetime',
                    // number: true,
                },
                // {
                //     name: 'Target',
                // },
                {
                    name: 'MSISDN',
                },
                {
                    name: 'Coordinate',
                },
                {
                    name: 'Action',
                    action: true,
                },
            ],

            total_data: 0,
            items_per_page: 10,

            size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,

            isAstro: process.env.VUE_APP_ASTRO,
            vendorMap: (typeof process.env.VUE_APP_VENDOR_MAP!==undefined || typeof process.env.VUE_APP_VENDOR_MAP!=='undefined'? process.env.VUE_APP_VENDOR_MAP: 'gmap'),
            circle_marker_radius: this.$store.getters.getTerritoryVirtualMarkerRadius,

            // openstreetmap
            // url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
            url: `${process.env.VUE_APP_OSM_CDN_URL}{z}/{x}/{y}.png`,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            locations: {
                territory:[],
                history:[]
            },
            polylineOSM: {
                latlngs:[],
                color:'#FF0000'
            },
            newLoc: '',
            newLt : 0, 
            newLng : 0,
            icon: L.icon({iconUrl: "null",}),
            rectangleOSM: {
                bounds: [[-6.18188099999998, 106.8211273227539], [-6.170255000000001, 106.83286432275388]],
                style: {
                    color: "#FF0000",
                    opacity: 0.8,
                    weight: 3,
                    fillColor: "#FFFFFF",
                    fillOpacity: 0.35,
                },
            },
        };
    },
    computed: {
        google: gmapApi,
        ...mapState([
            'load_data_status_territory_virtual_detail_map_data',
            // 'load_data_status_territory_virtual_detail_map_history',
            'load_data_status_territory_virtual_detail_history_list',
            'territory_virtual_detail_map_data',
            // 'territory_virtual_detail_map_history',
            'territory_virtual_detail_history_list',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            return this.$route.params.id;
        },
        target_id() {
            return this.$route.params.target_id;
        },
        msisdn() {
            return this.$route.params.msisdn;
        },
        rectangle: {
            get() {
                // console.log(Object.keys(this.rectangle_data).length);
                if (!this.rectangle_data)
                    return this.google.maps.Rectangle;

                return this.rectangle_data;
            },
            set(v) {
                this.rectangle_data = v;
            },
        },
    },
    watch: {
        google() {},
        route_name() {
            // this.getData();
        },
        id() {
            this.getData();
        },
        target_id() {
            this.getData();
        },
        msisdn() {
            this.getData();
        },
        rectangle() {},
        territory_virtual_detail_map_data(newData) {
            // if ((newData.target && newData.target.length > 0) || (newData.point && newData.point[0]))
            if ((newData.target_history && newData.target_history.length > 0) || (newData.point && newData.point[0]))
                this.startMap();
        },
        msisdn_selected() {},
        // msisdn_selected(newData) {
        //     console.log(newData)
        //     if (newData.length > 0)
        //         this.getHistoryData();
        //         // this.startMapHistory();
        // },
        target_selected(newData) {
            // console.log(newData)
            if (Object.keys(newData).length > 0)
                this.getHistoryData();
        },
        dateRange() {
            // console.log(newData);

            // this.from_date = moment(newData.startDate).format('YYYY-MM-DD');
            // this.to_date = moment(newData.endDate).format('YYYY-MM-DD');
        },

        // pagination
        territory_virtual_detail_history_list(newData) {
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);
            } else {
                this.total_data = 0;
            }
        },
        total_data() {},
        items_per_page() {
            this.getHistoryData('list');
        },
        page() {
            this.getHistoryData('list');
        },
    },
    methods: {
        // decrypt(string) {
        //     return decrypt(string);
        // },
        changeImgAvatar(e) {
            const file = e.target.files[0];
            this.ImgAvatar = URL.createObjectURL(file);
        },
        getDefaultImage(e) {
            e.target.src = this.ImgAvatar;
        },
        datetimeFormat(datetime) {
            // return moment(datetime, 'YYYY-MM-DDTHH:mm:ssZ').format('DD MMM YYYY HH:mm:ssZ');
            return moment(datetime, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
        },
        hideAllInfoWindows() {
            for (var j=0; j < this.infoWindows.length; j++) {
                this.infoWindows[j].close();
            }
        },
        mapBounds(point=null) {
            var self = this;

            self.$nextTick(() => {
                self.$refs.mapRefDetail.$mapPromise.then((map) => {
                    const google = self.google;
                    var bounds = new google.maps.LatLngBounds();

                    if (point !== null) {
                        bounds.extend(new google.maps.LatLng(parseFloat(point.north_east.lat), parseFloat(point.north_east.lng)));
                        bounds.extend(new google.maps.LatLng(parseFloat(point.south_west.lat), parseFloat(point.south_west.lng)));
                    } else {
                        bounds.extend(new google.maps.LatLng(self.bounds.north, self.bounds.east));
                        bounds.extend(new google.maps.LatLng(self.bounds.south, self.bounds.west));
                    }

                    // add markers to bounds
                    if (self.markers.length > 0) {
                        for (var i = 0; i < self.markers.length; i++) {
                            bounds.extend(new google.maps.LatLng(self.markers[i].position.lat(), self.markers[i].position.lng()));
                        }
                    }

                    // Apply fitBounds
                    map.fitBounds(bounds); 
                });
            });
        },
        /* eslint-disable no-unused-vars */
        dateFormat (classes, date) {
            if (!classes.disabled) {
                // console.log('on dateFormat')
                // console.log(moment(date.getTime())._d)

                // classes.disabled = date.getTime() > new Date();
                classes.disabled = moment(date.getTime()).subtract({ hours: 12})._d > new Date();
            }
            return classes;
        },
        sizeChange() {
            this.page = 0;
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        async pickerUpdate(e) {
            // console.log('========= DateRangePicker on update')
            // console.log(e)

            let ranges = moment(e.endDate.getTime()).diff(moment(e.startDate.getTime()), 'days') + 1;

            if (this.isAstro !== 'true' && ranges > 7) {
                const default_date = this.$store.getters.getDefaultDate();

                // this.dateRange.startDate = moment().toDate();
                // this.dateRange.endDate = moment().toDate();

                // this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                // this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
                this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();

                this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                this.getHistoryData('list');

                this.$swal.fire({
                    icon: 'error',
                    title: 'Date range is not more than 7 days!',
                    text: 'Your date range is ' + ranges + ' days.',
                    // confirmButtonText: 'Yes!',
                    // confirmButtonColor: '#DD6B55',
                    // showCancelButton: true,
                    // allowOutsideClick: false,
                })

                // return;
            } else {
                this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                this.getHistoryData('list');
            }
        },
        getMarkerOsmIcon(location){
            let iconColor = '#ffffff'
            if (location.iconColor){
                iconColor = location.iconColor
            }
            let stroke_width = '1.4';
            let stroke = 'black';
            // let mySvgString = '<svg width="64" height="64" viewBox="0 0 64 64" fill="<color-icon>" xmlns="http://www.w3.org/2000/svg"><path d="M31.5766 15.7225C35.366 15.7225 38.4379 12.6506 38.4379 8.86127C38.4379 5.07189 35.366 2 31.5766 2C27.7872 2 24.7153 5.07189 24.7153 8.86127C24.7153 12.6506 27.7872 15.7225 31.5766 15.7225Z" fill="<color-icon>" stroke="black" stroke-width="3"/><path d="M18 26.8175V41.4161C18 43.1679 19.4599 44.4817 21.0657 44.4817H23.9854L25.5911 59.5183C25.7372 60.9782 26.905 62 28.3649 62H34.6423C36.1022 62 37.2701 60.978 37.4161 59.5183L39.0219 44.4817H41.9416C43.6934 44.4817 45.0073 43.1679 45.0073 41.4161V26.8175C45.1533 14.9926 18 14.9926 18 26.8175Z" fill="<color-icon>" stroke="black" stroke-width="3" stroke-linejoin="round"/></svg>'
            let mySvgString = '<svg width="64" height="64" viewBox="0 0 64 64" fill="<color-icon>" xmlns="http://www.w3.org/2000/svg"><path d="M31.5766 15.7225C35.366 15.7225 38.4379 12.6506 38.4379 8.86127C38.4379 5.07189 35.366 2 31.5766 2C27.7872 2 24.7153 5.07189 24.7153 8.86127C24.7153 12.6506 27.7872 15.7225 31.5766 15.7225Z" fill="<color-icon>" stroke="'+ stroke +'" stroke-width="'+ stroke_width +'"/><path d="M18 26.8175V41.4161C18 43.1679 19.4599 44.4817 21.0657 44.4817H23.9854L25.5911 59.5183C25.7372 60.9782 26.905 62 28.3649 62H34.6423C36.1022 62 37.2701 60.978 37.4161 59.5183L39.0219 44.4817H41.9416C43.6934 44.4817 45.0073 43.1679 45.0073 41.4161V26.8175C45.1533 14.9926 18 14.9926 18 26.8175Z" fill="<color-icon>" stroke="'+ stroke +'" stroke-width="'+ stroke_width +'" stroke-linejoin="round"/></svg>'
            // let myIconUrl = encodeURI("data:image/svg+xml," + mySvgString).replace('<color-icon>',iconColor).replace('#','%23');
            // let myIconUrl = encodeURI("data:image/svg+xml;utf8," + mySvgString.replaceAll('<color-icon>',iconColor)).replaceAll('#','%23');
            let myIconUrl = encodeURI("data:image/svg+xml;utf8," + mySvgString.replace(/<color-icon>/g,iconColor)).replace(/#/g,'%23');

            return L.icon({
                iconUrl: myIconUrl,
                // iconSize: 40
                iconSize: 50,
                iconAnchor: [24.5, 49],
                popupAnchor: [0, -48],
            });
        },
        async startMap() {
            switch(this.vendorMap) {
              case 'osm':
                await this.startMapOSM();
                break;
              default:
                await this.startMapGMAP();
                break;
            }
        },
        async startMapOSM() {
            var self = this;
            // var mapsLatLng = [];

            self.locations.territory = [];
            self.polylineOSM.latlngs = [];

            // monas, jakarta
            this.center = {
                lat: -6.1763562,
                lng: 106.8227796,
            };

            this.mapLoaded = true;

            await self.$nextTick(() => {
                let map = self.$refs.mapRefOSM;
                if (map){
                    map = map.mapObject
                    if (map){

                        if (self.territory_virtual_detail_map_data.point && self.territory_virtual_detail_map_data.point[0]) {
                            self.rectangleOSM.bounds = [
                                [self.territory_virtual_detail_map_data.point[0].north_east.lat, self.territory_virtual_detail_map_data.point[0].north_east.lng],
                                [self.territory_virtual_detail_map_data.point[0].south_west.lat, self.territory_virtual_detail_map_data.point[0].south_west.lng]
                            ];
                            map.fitBounds(L.latLngBounds(self.rectangleOSM.bounds))
                        }

                        // if (self.territory_virtual_detail_map_data.target && self.territory_virtual_detail_map_data.target.length > 0) {
                        if (self.territory_virtual_detail_map_data.target_history && self.territory_virtual_detail_map_data.target_history.length > 0) {
                            // for (var i = 0; i < self.territory_virtual_detail_map_data.target.length; i++) {
                            for (var i = 0; i < self.territory_virtual_detail_map_data.target_history.length; i++) {

                                // Object.keys(self.territory_virtual_detail_map_data.target[i].coordinates).forEach(function(k){
                                Object.keys(self.territory_virtual_detail_map_data.target_history[i].coordinates).forEach(function(k){

                                    // if (Object.keys(self.territory_virtual_detail_map_data.target[i].coordinates[k]).length > 0) {
                                    if (Object.keys(self.territory_virtual_detail_map_data.target_history[i].coordinates[k]).length > 0) {

                                        // var dtm = (self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location ? self.datetimeFormat(self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location) : '-');
                                        // var dtm = (self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location ? self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location : '-');
                                        var dtm = (self.territory_virtual_detail_map_data.target_history[i].coordinates[k].datetime_location ? self.territory_virtual_detail_map_data.target_history[i].coordinates[k].datetime_location : '-');
                                        var contentString = '<div id="content">'+
                                          '<div id="bodyContent">'+
                                          '<table>'+
                                              '<tr>'+
                                                '<td class="pr-1 cell-info-window">Target</td>'+
                                                '<td class="pr-1 cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+self.territory_virtual_detail_map_data.target_history[i].target_name+'</td>'+
                                              '</tr>'+
                                              '<tr>'+
                                                '<td class="cell-info-window">MSISDN</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+k+'</td>'+
                                              '</tr>'+
                                              '<tr>'+
                                                '<td class="cell-info-window">Datetime</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+dtm+'</td>'+
                                              '</tr>'+
                                              '<tr>'+
                                                '<td class="cell-info-window">Radius</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+self.circle_marker_radius+' m</td>'+
                                              '</tr>'+
                                              '<tr>'+
                                                '<td class="cell-info-window">Link Location</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                // '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q='+self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lat+','+self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                                '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q='+self.territory_virtual_detail_map_data.target_history[i].coordinates[k].location[0].lat+','+self.territory_virtual_detail_map_data.target_history[i].coordinates[k].location[0].lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                                '</td>'+
                                              '</tr>'+
                                            '</table>'+
                                          '</div>'+
                                        '</div>';

                                        // let centerTmp = [self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lat, self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lng]
                                        let centerTmp = [self.territory_virtual_detail_map_data.target_history[i].coordinates[k].location[0].lat, self.territory_virtual_detail_map_data.target_history[i].coordinates[k].location[0].lng]
                                        // let labelColor = self.territory_virtual_detail_map_data.target[i].label
                                        let labelColor = self.territory_virtual_detail_map_data.target_history[i].label
                                        self.locations.territory.push({
                                            name: contentString,
                                            position: centerTmp,
                                            iconColor: labelColor
                                        });

                                        // ---------------------------------------------

                                        // var marker = new google.maps.Marker({
                                        //     // position: new google.maps.LatLng(parseFloat(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lat), parseFloat(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lng)),
                                        //     position: {
                                        //         lat: parseFloat(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lat),
                                        //         lng: parseFloat(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lng)
                                        //     },
                                        //     map: map,
                                        //     icon: icon,
                                        //     // draggable: true,
                                        // });

                                        // var circle = new google.maps.Circle({
                                        //     map: map,
                                        //     // radius: 500, // in metres
                                        //     radius: self.circle_marker_radius,
                                        //     // fillColor: self.marker_color[self.territory_virtual_detail_map_data.target[i].label],
                                        //     fillColor: self.territory_virtual_detail_map_data.target[i].label,
                                        //     fillOpacity: 0.25,
                                        //     strokeWeight: 1.25,
                                        //     strokeColor: '#ffffff',
                                        //     // strokeColor: '#242f3e',
                                        // });

                                        // circle.bindTo('center', marker, 'position');

                                        // self.markers.push(marker);

                                        // // var dtm = (self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location ? moment(self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location, 'YYYY-MM-DDThh:mm:ssZ').format('DD MMMM YYYY, hh:mm') : '-');
                                        // var dtm = (self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location ? self.datetimeFormat(self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location) : '-');
                                        
                                        // var contentString = '<div id="content">'+
                                        //       '<div id="bodyContent">'+
                                        //       '<table>'+
                                        //           '<tr>'+
                                        //             '<td class="pr-1 cell-info-window">Target</td>'+
                                        //             '<td class="pr-1 cell-info-window">:</td>'+
                                        //             '<td class="cell-info-window">'+self.territory_virtual_detail_map_data.target[i].target_name+'</td>'+
                                        //           '</tr>'+
                                        //           '<tr>'+
                                        //             '<td class="cell-info-window">MSISDN</td>'+
                                        //             '<td class="cell-info-window">:</td>'+
                                        //             '<td class="cell-info-window">'+k+'</td>'+
                                        //           '</tr>'+
                                        //           '<tr>'+
                                        //             '<td class="cell-info-window">Datetime</td>'+
                                        //             '<td class="cell-info-window">:</td>'+
                                        //             '<td class="cell-info-window">'+dtm+'</td>'+
                                        //           '</tr>'+
                                        //           '<tr>'+
                                        //             '<td class="cell-info-window">Radius</td>'+
                                        //             '<td class="cell-info-window">:</td>'+
                                        //             '<td class="cell-info-window">'+self.circle_marker_radius+' m</td>'+
                                        //           '</tr>'+
                                        //           '<tr>'+
                                        //             '<td class="cell-info-window">Link Location</td>'+
                                        //             '<td class="cell-info-window">:</td>'+
                                        //             '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q='+self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lat+','+self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                        //             '</td>'+
                                        //           '</tr>'+
                                        //         '</table>'+
                                        //       '</div>'+
                                        //       '</div>';

                                        // var infowindow = new google.maps.InfoWindow({
                                        //     content: contentString,
                                        //     maxWidth: 400
                                        // });
                                        
                                        // self.infoWindows.push(infowindow); 
                                        
                                        // google.maps.event.addListener(marker, 'click', function() {
                                        //   // hideAllInfoWindows(map);
                                        //   self.hideAllInfoWindows();
                                        //   infowindow.open(map, marker);
                                        // });
                                    }
                                });
                            }
                        }
                    }
                }
            });
        },
        async startMapGMAP() {
            var self = this;
            // var mapsLatLng = [];
            self.infoWindows = [];
            self.markers = [];
            self.mapsLatLng = [];
            self.polyline = null;

            // monas, jakarta
            this.center = {
                lat: -6.1763562,
                lng: 106.8227796,
            };

            this.mapLoaded = true;

            await self.$nextTick(() => {
                self.$refs.mapRefDetail.$mapPromise.then((map) => {
                    const google = self.google;

                    if (self.territory_virtual_detail_map_data.point && self.territory_virtual_detail_map_data.point[0]) {

                        let bounds_rectangle = {
                            north: parseFloat(self.territory_virtual_detail_map_data.point[0].north_east.lat),
                            east: parseFloat(self.territory_virtual_detail_map_data.point[0].north_east.lng),
                            south: parseFloat(self.territory_virtual_detail_map_data.point[0].south_west.lat),
                            west: parseFloat(self.territory_virtual_detail_map_data.point[0].south_west.lng),
                        };

                        self.rectangle = new google.maps.Rectangle({
                            strokeColor: "#FF0000",
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                            // fillColor: "#FF0000",
                            fillColor: "#FFF",
                            fillOpacity: 0.35,
                            // bounds: bounds,
                            bounds: bounds_rectangle,
                            // editable: true,
                            // draggable: true,
                        });

                        self.rectangle.setMap(map);
                        self.mapBounds(self.territory_virtual_detail_map_data.point[0]);
                    }

                    // map.center = new google.maps.LatLng(self.center);

                    // if (self.territory_virtual_detail_map_data.target && self.territory_virtual_detail_map_data.target.length > 0) {
                    if (self.territory_virtual_detail_map_data.target_history && self.territory_virtual_detail_map_data.target_history.length > 0) {
                        // for (var i = 0; i < self.territory_virtual_detail_map_data.target.length; i++) {
                        for (var i = 0; i < self.territory_virtual_detail_map_data.target_history.length; i++) {

                            // Object.keys(self.territory_virtual_detail_map_data.target[i].coordinates).forEach(function(k){
                            Object.keys(self.territory_virtual_detail_map_data.target_history[i].coordinates).forEach(function(k){

                                // if (Object.keys(self.territory_virtual_detail_map_data.target[i].coordinates[k]).length > 0) {
                                if (Object.keys(self.territory_virtual_detail_map_data.target_history[i].coordinates[k]).length > 0) {

                                    // console.log(marker_color[self.territory_virtual_detail_map_data.target[i].label]);

                                    // self.mapsLatLng[k] = new google.maps.LatLng(parseFloat(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lat), parseFloat(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lng));
                                    // self.mapsLatLng.push(new google.maps.LatLng(parseFloat(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lat), parseFloat(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lng)));

                                    var icon = {                                        
                                        path: 'M31.5766 15.7225C35.366 15.7225 38.4379 12.6506 38.4379 8.86127C38.4379 5.07189 35.366 2 31.5766 2C27.7872 2 24.7153 5.07189 24.7153 8.86127C24.7153 12.6506 27.7872 15.7225 31.5766 15.7225Z M18 26.8175V41.4161C18 43.1679 19.4599 44.4817 21.0657 44.4817H23.9854L25.5911 59.5183C25.7372 60.9782 26.905 62 28.3649 62H34.6423C36.1022 62 37.2701 60.978 37.4161 59.5183L39.0219 44.4817H41.9416C43.6934 44.4817 45.0073 43.1679 45.0073 41.4161V26.8175C45.1533 14.9926 18 14.9926 18 26.8175Z',
                                        // fillColor: self.marker_color[self.territory_virtual_detail_map_data.target[i].label],
                                        // fillColor: self.territory_virtual_detail_map_data.target[i].label,
                                        fillColor: self.territory_virtual_detail_map_data.target_history[i].label,
                                        fillOpacity: 1,
                                        // strokeWeight: 1.2,
                                        strokeWeight: 1.2,
                                        strokeColor: '#ffffff',
                                        // scale: 1.25,
                                        scale: .65,
                                        anchor: new google.maps.Point(30,65),
                                    }

                                    // console.log(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lat, self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lng);
                                    // console.log(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0]);
                                    // console.log(k);
                                    // console.log(new google.maps.Marker());
                                    var marker = new google.maps.Marker({
                                        // position: new google.maps.LatLng(parseFloat(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lat), parseFloat(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lng)),
                                        position: {
                                            // lat: parseFloat(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lat),
                                            lat: parseFloat(self.territory_virtual_detail_map_data.target_history[i].coordinates[k].location[0].lat),
                                            // lng: parseFloat(self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lng)
                                            lng: parseFloat(self.territory_virtual_detail_map_data.target_history[i].coordinates[k].location[0].lng)
                                        },
                                        map: map,
                                        icon: icon,
                                        // draggable: true,
                                    });
                                    // console.log(marker);

                                    // const cityCircle = new google.maps.Circle({
                                    //   strokeColor: "#FF0000",
                                    //   strokeOpacity: 0.8,
                                    //   strokeWeight: 2,
                                    //   fillColor: "#FF0000",
                                    //   fillOpacity: 0.35,
                                    //   map,
                                    //   center: citymap[city].center,
                                    //   radius: Math.sqrt(citymap[city].population) * 100
                                    // });

                                    var circle = new google.maps.Circle({
                                        map: map,
                                        // radius: 500, // in metres
                                        radius: self.circle_marker_radius,
                                        // fillColor: self.marker_color[self.territory_virtual_detail_map_data.target[i].label],
                                        // fillColor: self.territory_virtual_detail_map_data.target[i].label,
                                        fillColor: self.territory_virtual_detail_map_data.target_history[i].label,
                                        fillOpacity: 0.25,
                                        strokeWeight: 1.25,
                                        strokeColor: '#ffffff',
                                        // strokeColor: '#242f3e',
                                    });

                                    circle.bindTo('center', marker, 'position');

                                    self.markers.push(marker);

                                    // var dtm = (self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location ? moment(self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location, 'YYYY-MM-DDThh:mm:ssZ').format('DD MMMM YYYY, hh:mm') : '-');
                                    // var dtm = (self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location ? self.datetimeFormat(self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location) : '-');
                                    // var dtm = (self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location ? self.territory_virtual_detail_map_data.target[i].coordinates[k].datetime_location : '-');
                                    var dtm = (self.territory_virtual_detail_map_data.target_history[i].coordinates[k].datetime_location ? self.territory_virtual_detail_map_data.target_history[i].coordinates[k].datetime_location : '-');
                                    
                                    var contentString = '<div id="content">'+
                                          '<div id="bodyContent">'+
                                          '<table>'+
                                              '<tr>'+
                                                '<td class="pr-1 cell-info-window">Target</td>'+
                                                '<td class="pr-1 cell-info-window">:</td>'+
                                                // '<td class="cell-info-window">'+self.territory_virtual_detail_map_data.target[i].target_name+'</td>'+
                                                '<td class="cell-info-window">'+self.territory_virtual_detail_map_data.target_history[i].target_name+'</td>'+
                                              '</tr>'+
                                              '<tr>'+
                                                '<td class="cell-info-window">MSISDN</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+k+'</td>'+
                                              '</tr>'+
                                              '<tr>'+
                                                '<td class="cell-info-window">Datetime</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+dtm+'</td>'+
                                              '</tr>'+
                                              '<tr>'+
                                                '<td class="cell-info-window">Radius</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                '<td class="cell-info-window">'+self.circle_marker_radius+' m</td>'+
                                              '</tr>'+
                                              '<tr>'+
                                                '<td class="cell-info-window">Link Location</td>'+
                                                '<td class="cell-info-window">:</td>'+
                                                // '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q='+self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lat+','+self.territory_virtual_detail_map_data.target[i].coordinates[k].location[0].lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                                '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q='+self.territory_virtual_detail_map_data.target_history[i].coordinates[k].location[0].lat+','+self.territory_virtual_detail_map_data.target_history[i].coordinates[k].location[0].lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                                '</td>'+
                                              '</tr>'+
                                            '</table>'+
                                          '</div>'+
                                          '</div>';

                                    var infowindow = new google.maps.InfoWindow({
                                        content: contentString,
                                        maxWidth: 400
                                    });
                                    
                                    self.infoWindows.push(infowindow); 
                                    
                                    google.maps.event.addListener(marker, 'click', function() {
                                      // hideAllInfoWindows(map);
                                      self.hideAllInfoWindows();
                                      infowindow.open(map, marker);
                                    });
                                }
                            });
                        }
                    }

                    if (self.mapsLatLng.length > 0) {
                        self.polyline = new google.maps.Polyline({
                          path: self.mapsLatLng,
                          strokeColor: '#FF0000',
                          strokeOpacity:0.8,
                          strokeWeight:1.5
                        });

                        self.polyline.setMap(map);
                    }

                });
            });
        },
        async getData() {
            await this.$store.commit('setTerritoryVirtualDetailMapData', {});
            this.$store.commit('setTerritoryVirtualDetailMapHistory', {});
            this.$store.commit('setTerritoryVirtualDetailHistoryList', {});

            if (this.route_name === 'PageTerritoryVirtualDetailNotification') {
                this.showLoading(true);
                const default_date = this.$store.getters.getDefaultDate();

                if (this.from_date === '') {
                    // this.dateRange.startDate = moment().toDate();
                    // this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');

                    this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
                    this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                }

                if (this.to_date === '') {
                    // this.dateRange.endDate = moment().toDate();
                    // this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                    this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();
                    this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');
                }

                this.$store.dispatch('getTerritoryVirtualDetailMapData', [this.id, this.target_id, decrypt(this.msisdn)])
                .then((resp) => {
                    if (resp === 'success') {
                        this.showLoading(false);
                    } else {
                        this.error();
                    }
                });

                // await this.$store.dispatch('getTerritoryVirtualDetailHistory', [this.id, this.target_id, decrypt(this.msisdn), this.items_per_page, (parseInt(this.page) + 1)]);
                // this.pagination();

                this.getHistoryData();
            }
        },
        async getHistoryData(section='all') {

            // if (section === 'all' || section === 'map') {
            //     // this.target_selected = {};
            //     // this.msisdn_selected = '';
            //     this.mapHistoryLoaded = false;
            //     this.markers_history = [];
            //     this.infoWindowsHistory = [];
                
            //     this.$store.commit('setTerritoryVirtualDetailMapHistory', {});
            //     this.$store.dispatch('getTerritoryVirtualDetailHistory', [this.id, this.target_selected.id, parseInt(this.target_selected.msisdn), '', '', this.from_date, this.to_date])
            //     .then((resp) => {
            //         if (resp === 'success') {
            //             this.startMapHistory();
            //         } else {
            //             this.error();
            //         }
            //     });
            // }

            // console.log(this.from_date, this.to_date)

            if (section === 'all' || section === 'list') {
                // this.$store.commit('setTerritoryVirtualDetailHistoryList', {});
                await this.$store.dispatch('getTerritoryVirtualDetailHistory', [this.id, this.target_id, parseInt(decrypt(this.msisdn)), this.items_per_page, (parseInt(this.page) + 1), this.from_date, this.to_date]);
                this.pagination();
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null, data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: (message!==null ? message : 'Something wrong.'),
                html: errors,
                // timer: 3000
            });
        },
    },
    filters: {
      date: function (date) {
        return moment(date).format('YYYY-MM-DD');
      }
    },
    async mounted() {
        // await this.startMap();
        await this.getData();
        EventEmit.$on('territoryNotificationOnDetail', () => {
            this.getData();
        });
    },
}
</script>

<style lang="sass">
    .draw-area
        height: 500px
    .cell-info-window
        vertical-align: top
</style>
